import { find, map, propEq } from 'ramda';

export const getSelected = (selected, items) => map(id => find(propEq('id', id), items), selected);
